import { SLICE_NAME } from "../../model/types";

export const ActionType = {
  INFINITY_SELECT_OPEN: `${SLICE_NAME}/infinity_select_open`,
  INFINITY_SELECT_CLOSE: `${SLICE_NAME}/infinity_select_close`,
  INFINITY_SELECT_LOAD_MORE: `${SLICE_NAME}/infinity_select_load_more`,
} as const;
